import { reactive } from 'vue'

const state = reactive({
  userAuth: false
})

export default state
